import { Ref, ref } from "@vue/composition-api"
import { HttpResponse } from "../../api/request"
import { api } from "../../api"
import { BookingModel } from "@/app/models/booking.model"
import { useCallbacksTCS } from "../merchant-callbacks/callbacks-tcs.reactive"

export function useStartBooking() {
  const isStartBookingPending = ref(false)
  const { callbacks } = useCallbacksTCS()

  async function startBooking(
    booking: Ref<BookingModel>,
  ): Promise<HttpResponse<any>> {
    isStartBookingPending.value = true
    const response = await api.startBooking(booking.value.referenceId)
    isStartBookingPending.value = false
    if (response.wasSuccessful && response.data) {
      booking.value.state = response.data.state
      booking.value.startedAt = new Date(response.data.startedAt as any)

      // Call the corresponding callback to the TCS Frontend App (Via Webview JS Bridge)
      callbacks.success()
    } else {
      // TODO: Clarify with Christian if thats okay to call error in that case
      callbacks.error()
    }

    return response
  }

  return { startBooking, isStartBookingPending }
}
